/**
 * MosaicStudentFlags.js — v6.32.164
 *
 * Compact row of flag chips for a student. Surfaces the SIFE / Newcomer
 * / IEP / Former-ELL indicators next to a student's name so teachers
 * can see priority status at a glance.
 */
import React from 'react';

const FLAG_STYLES = {
  newcomer:   { label: 'NEW',  bg: 'bg-rose-100 border-rose-300 text-rose-800' },
  sife:       { label: 'SIFE', bg: 'bg-violet-100 border-violet-300 text-violet-800' },
  iep_504:    { label: 'IEP',  bg: 'bg-amber-100 border-amber-300 text-amber-800' },
  former_ell: { label: 'F-ELL', bg: 'bg-blue-100 border-blue-300 text-blue-800' },
};

const MosaicStudentFlags = ({ intake, compact = false }) => {
  if (!intake) return null;
  const flags = Object.keys(FLAG_STYLES).filter((k) => !!intake[k]);
  if (flags.length === 0) return null;
  return (
    <span className="inline-flex items-center gap-1 ml-1" data-testid="mosaic-student-flags">
      {flags.map((k) => {
        const s = FLAG_STYLES[k];
        return (
          <span
            key={k}
            data-testid={`mosaic-flag-${k}`}
            className={`inline-flex items-center px-1.5 py-0.5 border ${s.bg} ${compact ? 'text-[9px]' : 'text-[10px]'} font-bold uppercase tracking-wider`}
            title={k.replace('_', '/').toUpperCase()}
          >
            {s.label}
          </span>
        );
      })}
    </span>
  );
};

export default MosaicStudentFlags;
